import type { Component } from 'vue'
import {
  Boxes,
  Database,
  GaugeCircle,
  Layers,
  ScrollText,
  Server,
  Users,
  Wrench,
} from 'lucide-vue-next'

export interface NavItem {
  label: string
  to: string
  icon: Component
  comingSoon?: boolean
  adminOnly?: boolean
}

// Task-oriented operator IA (plan §3.1). Only Tenants is fully built in Phase 2;
// everything else renders with a "soon" tag and routes to the ComingSoon view.
// adminOnly items are filtered in by AppSidebar against authStore.isAdmin.
export const NAV_ITEMS: NavItem[] = [
  { label: 'Ops Dashboard', to: '/', icon: GaugeCircle, comingSoon: true },
  { label: 'Tenants', to: '/tenants', icon: Boxes },
  { label: 'Rollouts', to: '/rollouts', icon: Layers, comingSoon: true },
  { label: 'Resource State', to: '/resources', icon: Database, comingSoon: true },
  { label: 'Reconcile Hub', to: '/reconcile', icon: Wrench, comingSoon: true },
  { label: 'Infrastructure', to: '/infrastructure', icon: Server, comingSoon: true },
  { label: 'Audit Log', to: '/audit-log', icon: ScrollText, comingSoon: true, adminOnly: true },
  { label: 'User Management', to: '/users', icon: Users, adminOnly: true },
]
